import React, {Component} from 'react';
import CalcMenu from "./components/CalcMenu";
import {store, history} from "./store";
import {Provider} from "react-redux";
import {ConnectedRouter} from "react-router-redux";
import {Redirect, Route, Switch} from "react-router-dom";

import SelecteurPoduits from "./pages/SelecteurProduits";
import Panier from "./pages/Panier";
import {produitsEcransCibles, produitsEcransEnsemble, produitsNumeriques} from "./data/Produits";

import enhancePrototypes from './utils/enhancePrototypes';

enhancePrototypes();

class App extends Component {

  render() {
    return (
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <div>
              <CalcMenu/>
              <Switch>
                <Route path={'/ecran-ensemble'} render={() => <SelecteurPoduits produits={ produitsEcransEnsemble }/>}/>
                <Route path={'/:base/ecran-ensemble'} render={() => <SelecteurPoduits produits={ produitsEcransEnsemble }/>}/>
                <Route path={'/ecran-cible'} render={() => <SelecteurPoduits produits={ produitsEcransCibles }/>}/>
                <Route path={'/:base/ecran-cible'} render={() => <SelecteurPoduits produits={ produitsEcransCibles }/>}/>
                <Route path={'/numerique'} render={() => <SelecteurPoduits produits={ produitsNumeriques }/>}/>
                <Route path={'/:base/numerique'} render={() => <SelecteurPoduits produits={ produitsNumeriques }/>}/>
                <Route path={'/panier'} component={Panier}/>
                <Route path={'/:base/panier'} component={Panier}/>
                <Redirect to='./ecran-ensemble'/>
              </Switch>
            </div>
          </ConnectedRouter>
        </Provider>
    );
  }
}

export default App;
